import React from "react";
import Proptypes from "prop-types";
import styled, { css } from "styled-components";
import ToolGroup from "./toolGroup";
import Search from "./search";
import Filter from "./filter";
import Button from "./button";
import { useState } from "react";
import Modal from './modals/modal'
const modeVariants = {
  normal: css`
    padding: 5px 5px 5px 10px;
    font-size: ${({ theme }) => theme.fontSize.normal};
  `,
  mini: css`
    padding: 1px;
    font-size: ${({ theme }) => theme.fontSize.lsmal};
  `,
};

// 搜索框组件样式
const StyledToolsBar = styled.nav`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  ${({ mode }) => modeVariants[mode]}
  border: 1px solid ${({ theme }) => theme.backgroundColor};
  border-radius: 3px;
  border-left: solid 5px ${({ theme }) => theme.quoteBorderGray};
  color: ${({ theme }) => theme.quoteGray};
`;

// 用来存放添加按钮以及其他的工具的盒子组
const StyledSearchGroup = styled.div`
  display: flex;
  align-items: center;
`;

// 控制按钮和添加在一行上显示的盒子
const BoxUploadAdd = styled.div`
  display: flex;
  align-items: center;
`
// search = {
//   value,
//   setValue,
//   onSearch
// }

const ToolsBar = ({
  auth,
  mode = "normal",
  tools = [],
  search = null,
  filter = null,
  buttonContent = "批量发布版本",
  handleButtonClick = null,
  hasButton = false,
  totalFileNum
}) => {
  return (
    <>
    <StyledToolsBar mode={mode}>
      <StyledSearchGroup>
        {filter && <Filter />}
        {search ? <Search mode={mode} {...search} /> : "工具栏"}
      </StyledSearchGroup>
      {totalFileNum ? '文件总数量：' + totalFileNum : ''}
      <BoxUploadAdd>
        {
          hasButton && <Button title={buttonContent} auth={auth} onClick={ handleButtonClick }>{buttonContent}</Button>
        }
        <ToolGroup auth={auth} tools={tools} />
      </BoxUploadAdd>
    </StyledToolsBar>
    </>
  );
};

ToolGroup.propTypes = {
  tools: Proptypes.arrayOf(Proptypes.object),
};

export default ToolsBar;
